import React from 'react';
import PhoneInput from 'react-phone-input-2';
import { IPhoneInputField } from './PhoneInputField.types';

// Didn't use CSS module because the library doesn't obey CSS module. The CSS is still BEM.
import './PhoneInputField.scss';
import 'react-phone-input-2/lib/high-res.css';

const PhoneInputField = ({
  onChange,
  value,
  disabled,
  name,
  label,
  placeholder,
  isShowLabel,
  error
}: IPhoneInputField) => {
  return (
    <div>
      {label && <div className="phone-input__label">{label}</div>}
      <div className={`phone-input ${disabled && 'phone-input--disabled'}`}>
        <PhoneInput
          country="ca"
          onChange={onChange}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          containerClass="phone-input__content"
          inputClass={`phone-input__textfield ${
            error && !isShowLabel && 'phone-input__textfield--errored'
          } ${isShowLabel && value && 'phone-input__textfield--valued'} ${
            isShowLabel && 'phone-input__textfield--labelled'
          }`}
          dropdownClass="phone-input__dropdown"
          searchClass="phone-input__search"
          specialLabel={label}
          enableSearch
          searchPlaceholder="Search"
          inputProps={{
            name
          }}
        />
        <div className="phone-input__error">{error && error}</div>
      </div>
    </div>
  );
};

export default PhoneInputField;
